import React, { ReactNode, useContext, useCallback } from 'react';
import {
  withLocalization,
  withLocalizationProps,
  ConfigContext,
} from '../../context/Config';
import Text from '../Text';
import { SummeryType } from '../../types';
import './UpcomingSessionCard.less';

type SessionType = {
  groupTitle?: string;
  date?: string | '';
};

export type { SessionType };

type UpcomingSessionCardProps = {
  title?: string | ReactNode;
  session?: SessionType;
  size?: SummeryType;
  noSessionText: string;
  onClick?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const TUpcomingSessionCard: React.FC<
  UpcomingSessionCardProps & withLocalizationProps
> = ({ title, session, noSessionText, moment }) => {
  const { translate } = useContext(ConfigContext);

  const getTimeLeft = useCallback(() => {
    const days = moment(session?.date).diff(moment(), 'day');
    if (days < 1) {
      const hours = moment(session?.date).diff(moment(), 'hour');
      if (hours < 1) {
        return `${moment(session?.date).diff(moment(), 'minutes')} ${translate(
          'minutes',
          {},
          false,
        )}`;
      }
      return `${hours} ${translate('hours', {}, false)}`;
    }
    return `${days} ${translate('days', {}, false)}`;
  }, [session]);

  return (
    <div className="t-upcomingSessionRow-1">
      <div className="t-upcoming-session-first-row">
        <div>
          <Text level={2} rows={1} bold>
            {title || ''}
          </Text>
        </div>
        {session.date && (
          <div>
            <Text level={3} rows={1}>
              {translate('will start in {{timeLeft}}', {
                timeLeft: getTimeLeft(),
              })}
            </Text>
          </div>
        )}
        {!session.date && (
          <div className="t-noSession">
            <Text level={3} rows={1}>
              {noSessionText || ''}
            </Text>
          </div>
        )}
      </div>
    </div>
  );
};

export default withLocalization(TUpcomingSessionCard);
